import React from 'react';
import { SizeBoxesLiNewV2, SizeBoxesNewContainer } from './styled';

function DiaperSizeBoxes(props) {
  const {
    showNewDiaperVariantUx,
    varientTitle,
    sizeClickHandler,
    element,
    index,
    focusElement,
    selectedSize,
    packsCount,
    showCDNewVariantUx,
  } = props;

  const sizeWeightMapping = {
    'New Born': 'Upto 5 kg',
    'NB- Pant': 'Upto 5 kg',
    'S': '4-8 kg',
    'M': '7-12 kg',
    'L': '9-14 kg',
    'XL': '12-17 kg',
    'XXL': '15-25 kg',
    'XXXL': '18-35 kg',
  };
  const sizeTitleMapping = {
    'New Born': 'New Born',
    'NB- Pant': 'New Born',
    'S': 'Small',
    'M': 'Medium',
    'L': 'Large',
    'XL': 'Extra Large',
    'XXL': 'XXL',
    'XXXL': 'XXXL',
  };
  const getDiscount = (element) => {
    const { price, strikeprice } = element;
    let str = Math.ceil(((strikeprice - price) / strikeprice) * 100) + '% OFF';
    return str;
  };

  const getPricePerUnit = (element) => {
    const { price, quantityPerPack, packPerProduct } = element;
    return `₹ ${(price / (quantityPerPack * packPerProduct)).toFixed(2)}`;
  };

  console.log(element.title);

  return (
    <SizeBoxesNewContainer botPadding={varientTitle?.toLowerCase() != 'size'}>
      {showNewDiaperVariantUx && varientTitle?.toLowerCase() != 'size' ? (
        index == 0 ? (
          varientTitle?.toLowerCase() != 'size' && (
            <div className="lowestPrice">Lowest price</div>
          )
        ) : (
          <div style={{ visibility: 'hidden' }}>Hide</div>
        )
      ) : null}
      <SizeBoxesLiNewV2
        id={`${element.name + index}`}
        key={varientTitle + index}
        style={{
          opacity: focusElement == index ? 0.4 : 1,
          borderTopLeftRadius:
            index == 0 &&
            varientTitle?.toLowerCase() != 'size' &&
            varientTitle?.toLowerCase() != 'design'
              ? '0px'
              : '',
        }}
        onClick={() => sizeClickHandler(element, index)}
        active={selectedSize == element?.title}
        botPadding={varientTitle?.toLowerCase() == 'size'}
        packsCount={packsCount}
        showCDNewVariantUx={showCDNewVariantUx}
      >
        {varientTitle?.toLowerCase() == 'size' ? (
          <>
            <p className="sizeTag">{sizeTitleMapping[element?.title]}</p>
            <p className="weightTag">{sizeWeightMapping[element?.title]}</p>
          </>
        ) : (
          <>
            <p className="packTag">
              {showCDNewVariantUx
                ? element.title
                : `
                            ${element?.quantityPerPack * element?.packPerProduct} 
                            ${
                              [3936, 3912].includes(element?.product_id)
                                ? 'Pant Diapers'
                                : [3987, 4093].includes(element?.product_id)
                                  ? 'Tape Diapers'
                                  : 'Diapers'
                            }
                        `}
            </p>
            <img src={element?.images?.[0]} alt="" />
            <div style={{ padding: '8px 2px 0' }}>
              {!showCDNewVariantUx ? (
                <p className="pricePerUnit">
                  <b>{getPricePerUnit(element)}</b>
                  <span> / diaper</span>
                </p>
              ) : null}
              <div className="priceFlex">
                <p className="strikeprice">{'₹' + element?.strikeprice}</p>
                <p className="discount">{getDiscount(element)}</p>
              </div>
              <p className="price">
                <span>You Pay </span>
                {'₹' + element?.price}
              </p>
            </div>
          </>
        )}
      </SizeBoxesLiNewV2>
    </SizeBoxesNewContainer>
  );
}

export default DiaperSizeBoxes;
